import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import i18n from './i18n';
import '../styles-v2/Contacto.css';
import { useTranslation } from 'react-i18next';

const Contacto = () => {
    const { t } = useTranslation();
    const { lang } = useParams();

    const [consulta, setConsulta] = useState('');
    const [formStatus, setFormStatus] = useState(null);
    const contactoRef = useRef(null);
    const textareaRef = useRef(null);
    const [isContactoVisible, setIsContactoVisible] = useState(false);

    // DATOS DE CONTACTO
    const formspreeUrl = "https://formspree.io/f/xandbvjg";
    const emailContact = "ingpozzi@yahoo.com.ar";
    const whatsappNumber = "542284532582";

    // 3. Sincronización de idioma con la URL
    useEffect(() => {
        if (lang && i18n.language !== lang) {
            i18n.changeLanguage(lang).catch(err => console.error(err));
        }
    }, [lang]);

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        const form = e.target;
        const data = new FormData(form);
        setFormStatus('sending');

        try {
            const response = await fetch(formspreeUrl, {
                method: 'POST',
                body: data,
                headers: { 'Accept': 'application/json' }
            });

            if (response.ok) {
                setFormStatus('success');
                setConsulta("");
                form.reset();
            } else {
                setFormStatus('error');
            }
        } catch (error) {
            setFormStatus('error');
        }
    };

    const handleAutoResize = (element) => {
        element.style.height = 'auto';
        element.style.height = (element.scrollHeight) + 'px';
    };

    useEffect(() => {
        const elementoActual = contactoRef.current;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsContactoVisible(true);
                }
            },
            { threshold: 0.3 } // Ajustado a 0.3 para mejor respuesta en móviles
        );

        if (elementoActual) {
            observer.observe(elementoActual);
        }

        return () => {
            if (elementoActual) {
                observer.unobserve(elementoActual);
            }
        };
    }, []);

    return (
        <section
            id="contacto"
            className={`section contacto fade-in-section ${isContactoVisible ? 'is-visible' : ''}`}
            ref={contactoRef}
        >
            <h2>{t('contact.title')}</h2>
            <div className="contact-content">

                {/* --- IZQUIERDA: DATOS --- */}
                <div className="contact-left">
                    <div className="contact-info">
                        <h3>{t('contact.options_title')}</h3>

                        <div className="contact-item">
                            <h4>{t('contact.email_label')}</h4>
                            <a href={`mailto:${emailContact}?body=${encodeURIComponent(t('contact.mailto_body'))}`}>
                                <span className="break-all">{emailContact}</span>
                            </a>
                        </div>

                        <div className="contact-item">
                            <h4>{t('contact.owner_label')}</h4>
                            <a href="https://www.linkedin.com/in/v%C3%ADctor-pozzi-458437251/" target="_blank" rel="noopener noreferrer">
                                <span> Ing. Víctor Pozzi </span>
                            </a>
                        </div>

                        <div className="contact-item whatsapp-container">
                            <h4>{t('contact.whatsapp_label')}</h4>
                            <a
                                href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(t('contact.whatsapp_text'))}`}
                                className="whatsapp-link"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i className="fab fa-whatsapp whatsapp-icon"></i>
                                <span>+54 2284 532582</span>
                            </a>
                        </div>

                        <div className="contact-item">
                            <h4>{t('contact.location_label')}</h4>
                            <p>{t('contact.location_value')}</p>
                        </div>
                    </div>
                </div>

                {/* --- DERECHA: FORMULARIO --- */}
                <div className="contact-right">
                    <div className="contact-form-container">
                        <h3>{t('contact.form_title')}</h3>

                        <form onSubmit={handleFormSubmit} className="contact-form">
                            <div className="form-group">
                                <label htmlFor="subject">{t('contact.label_subject')}</label>
                                <input type="text" id="subject" name="subject" required />
                            </div>
                            <div className="form-group">
                                <label htmlFor="email">{t('contact.label_email')}</label>
                                <input type="email" id="email" name="email" required />
                            </div>
                            <div className="form-group">
                                <label htmlFor="consulta">{t('contact.label_message')}</label>
                                <textarea
                                    ref={textareaRef}
                                    id="consulta"
                                    name="consulta"
                                    rows="1"
                                    required
                                    value={consulta}
                                    onChange={(e) => {
                                        setConsulta(e.target.value);
                                        handleAutoResize(e.target);
                                    }}
                                    style={{ resize: "none", overflow: "hidden" }}
                                />
                            </div>
                            <button type="submit">{t('contact.btn_send')}</button>
                        </form>

                        {formStatus === 'success' &&
                            <p style={{ color: '#546c5b', marginTop: '1rem', fontWeight: 'bold' }}>
                                {t('contact.msg_success')}
                            </p>}
                        {formStatus === 'error' &&
                            <p style={{ color: '#ff6b6b', marginTop: '1rem', fontWeight: 'bold' }}>
                                {t('contact.msg_error')}
                            </p>}
                        {formStatus === 'sending' &&
                            <p style={{ color: '#778CB4', marginTop: '1rem' }}>
                                {t('contact.msg_sending')}
                            </p>}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contacto;